const project = {
  slug: "detail_drawing",
  title: "What I Learned from My First Detail Design",
  category: "Article",
  date: "2025/02/18",
  excerpt: "A reflection on the intricate process of my first detail design — bridging fabrication and installation through endless problem-solving.",
  hero: "/images/projects/detail_drawing/hero.jpg",
  heroSmall: "/images/projects/detail_drawing/hero.jpg",
  heroThumb: "/images/projects/detail_drawing/hero.thumb.jpg",
  thumb: "/images/projects/detail_drawing/thumbnail.jpg",
  thumbPlaceholder: "/images/projects/detail_drawing/thumbnail.thumb.jpg",
  content: [
    {
      type: "image",
      src: "/images/projects/detail_drawing/1.jpg",
      alt: "detail drawing image",
      placeholder: "/images/projects/detail_drawing/1.thumb.jpg",
    },
    {
      type: "paragraph",
      text: `If I were to define what I do in one phrase, it would be — “So, how will this be made (fabricated) and how will it be installed (constructed)?” It sounds simple, but once you start thinking deeply, one issue leads to another, and the process becomes an endless pursuit — that’s what detail design is.`,
    },
    {
      type: "paragraph",
      text: `The main considerations that keep coming up are as follows:`,
    },
    {
      type: "paragraph",
      text: `- The structure must be able to resolve bending and moments effectively.`,
    },
    {
      type: "paragraph",
      text: `- The welding sequence should be planned so that as much as possible can be done in the factory. Welding mid-air on site is difficult, and it can leave soot on finished surfaces.`,
    },
    {
      type: "paragraph",
      text: `- Water treatment must be addressed — whether by water stops or trenches.`,
    },
    {
      type: "paragraph",
      text: `- There must be enough space for a person to work, especially room for hand movement.`,
    },
    {
      type: "paragraph",
      text: `- During lifting and installation, components should fit between the supports. (This detail actually had to be completely redone because of this issue.)`,
    },
    {
      type: "paragraph",
      text: `- It’s best if most of the design can be solved with standard details — minimizing special cases and using prefabricated parts.`,
    },
    {
      type: "paragraph",
      text: `- And ideally, all these details should remain invisible.`,
    },
    {
      type: "paragraph",
      text: `All these conditions intertwine in three dimensions and never stop needing resolution. Drawing in plan, modeling in 3D, simulating installation — it’s an infinite loop.`,
    },
    {
      type: "paragraph",
      text: `It is difficult, but as my team leader says, “It’s fun.”`,
    },
  ],
};

export default project;
